import React from "react";
import { connect } from "react-redux";
import { getOrganizations } from "./actions";
import _ from "@/utils/lodash-optimized";

const mapStateToProps = redux => ({
    organizations: redux?.admin?.organizations ?? [],
  redux: redux
});

class Organizations extends React.Component {
  UNSAFE_componentWillMount() {
    const { dispatch } = this.props;
    dispatch(getOrganizations());
  }

  render() {
    const { organizations } = this.props;

    const sub = entities =>
      Object.keys(entities).map(name => (
        <li key={name + "2"} style={{ listStyleType: "circle" }}>
          {entities[name].name}
        </li>
      ));

    const rendered = Object.keys(organizations).map(name => {
      const org = organizations[name];
      return (
        <div key={name}>
          <h2> {org.name} </h2>
            <ul key={name + "1"}> {sub(org?.entities)} </ul>
        </div>
      );
    });

    return (
      <div>
        <h1><b>Organizations</b></h1>
        {rendered}
      </div>
    );
  }
}

export default connect(mapStateToProps)(Organizations);
